const objSignLightInsp = {
  accessCondRate: "",
  baseCondRate: "",
  brkey: "",
  columnCondRate: "",
  grailCondRate: "",
  horCondRate: "",
  inspectionId: "",
  lightCondRate: "",
  createdDateTime: "",
  nextSignInspType: "",
  signAssetTag: "",
  signCondRate: "",
  signInspType: "",
  strRating: "",
  surfaceCondRate: "",
  createdUserId: "",
};
export default objSignLightInsp;
